import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { BreachPathDetailsDataProviderFactory } from '../factory/BreachPathDetailsDataProviderFactory';
import { BreachPathDetailsBaseDataProvider } from '../dataProvider/BreachPathDetailsBaseDataProvider';


export class BreachPathDetailsRepository extends BaseWebComponentRepository {
  public dataProviderFactory: BreachPathDetailsDataProviderFactory;
  public dataProvider: BreachPathDetailsBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new BreachPathDetailsDataProviderFactory(),
    });
  }
}
